/**
 * Returns how many vertical pixels remain before the combined
 * bounding‑box of all direct children would overflow the container.
 * If there are no children, returns the full clientHeight.
 * If already overflowing, returns 0.
 */
export function getRemainingVerticalSpace(el: HTMLElement): number {
  // 1. Grab container height
  const innerHeight = el.clientHeight

  // 2. Find the topmost and bottommost edges of all direct children
  let minChildTop = Infinity
  let maxChildBottom = -Infinity

  for (const node of Array.from(el.children)) {
    const childRect = node.getBoundingClientRect()
    minChildTop = Math.min(minChildTop, childRect.top)
    maxChildBottom = Math.max(maxChildBottom, childRect.bottom)
  }

  // 3. If no children, everything is free
  if (minChildTop === Infinity) {
    return innerHeight
  }

  // 4. Compute the “used” span (in px)
  const usedSpan = maxChildBottom - minChildTop

  // 5. Subtract from container’s inner height, clamp at 0
  return Math.max(0, innerHeight - usedSpan)
}
